module.exports = __webpack_public_path__ + "icons.fee66e712a8a08eef580.woff";


//////////////////
// WEBPACK FOOTER
// /var/www/luvi/frontend/src/assets/semantic/src/themes/themes/default/assets/fonts/icons.woff
// module id = ../../../../../src/assets/semantic/src/themes/themes/default/assets/fonts/icons.woff
// module chunks = styles